import { epochOfLocalDateTime, plannedInstantOf, type LocalDateTime } from '@wiztime/core';

const HOUR_MS = 3_600_000;
/** A completion time is read within 12 hours either side of a timed occurrence (data dictionary §3.2). */
const TIMED_HALF_WINDOW_MS = 12 * HOUR_MS;

/**
 * Start of the 24-hour span a typed completion time ("HH:mm") is read in: 12 hours before a
 * timed occurrence, so 05:00 typed for an overdue 03:00 dose is the same morning; the personal
 * day for an untimed one. It never starts before the earliest completion time storage accepts.
 */
export function doneWindowStart(occursAt: LocalDateTime | null, personalDate: string, dayStartMin: number): number {
  return occursAt === null
    ? plannedInstantOf(personalDate, dayStartMin, dayStartMin)
    : epochOfLocalDateTime(occursAt) - TIMED_HALF_WINDOW_MS;
}

/** First instant at or after `windowStart` whose local wall clock reads `min`. */
export function instantOfWallMinute(windowStart: number, min: number): number {
  const day = new Date(windowStart);
  const at = new Date(day.getFullYear(), day.getMonth(), day.getDate(), Math.floor(min / 60), min % 60);
  if (at.getTime() < windowStart) at.setDate(at.getDate() + 1);
  return at.getTime();
}

/** Local wall-clock minute of `ms` when it lies in the 24 hours from `windowStart`, else null. */
export function wallMinuteInWindow(windowStart: number, ms: number): number | null {
  if (ms < windowStart || ms >= windowStart + 24 * HOUR_MS) return null;
  const date = new Date(ms);
  return date.getHours() * 60 + date.getMinutes();
}
